export default {"src":"/_next/static/media/teams.80754b78.svg","height":2073,"width":2229,"blurWidth":0,"blurHeight":0};